import React, { ReactNode, ReactElement } from 'react';
import styles from './content-card-container.module.scss';

const UserAccessContentCardContainer = ({ children }: { children: ReactNode }): ReactElement => {
  return <div className={styles.container}>{children}</div>;
};

export default UserAccessContentCardContainer;
